import {
  ADD_SCHOR_HORIZONTAL,
  EDIT_SCHOR_HORIZONTAL,
  LIST_SCHOR_HORIZONTAL,
  VIEW_SCHOR_HORIZONTAL,
  DELETE_SCHOR_HORIZONTAL,
  // text
  ADD_SCHOR_HORIZONTAL_TEXT,
  EDIT_SCHOR_HORIZONTAL_TEXT,
  LIST_SCHOR_HORIZONTAL_TEXT,
  VIEW_SCHOR_HORIZONTAL_TEXT,
  DELETE_SCHOR_HORIZONTAL_TEXT,
  SCHOR_HORIZONTAL_SUCCESS,
  SCHOR_HORIZONTAL_ERROR,

} from "./actionTypes"

// add schor horizontal
export const addSchorHorizontal = (data, history, callback) => {
  return {
    type: ADD_SCHOR_HORIZONTAL,
    payload: { data, history, callback }
  }
}

// edit schor horizontal
export const editSchorHorizontal = (data, id, callback) => {
  return {
    type: EDIT_SCHOR_HORIZONTAL,
    payload: { data, id, callback },
  }
}

// list schor horizontal
export const listSchorHorizontal = (data, callback) => {
  return {
    type: LIST_SCHOR_HORIZONTAL,
    payload: { data, callback },
  }
}

// view schor horizontal
export const viewSchorHorizontal = (data, history) => {
  return {
    type: VIEW_SCHOR_HORIZONTAL,
    payload: { data, history },
  }
}

// delete schor horizontal
export const deleteSchorHorizontal = (data, callback) => {
  return {
    type: DELETE_SCHOR_HORIZONTAL,
    payload: { data, callback },
  }
}

// text
// add schor horizontal text
export const addSchorHorizontalText = (data, history, callback) => {
  return {
    type: ADD_SCHOR_HORIZONTAL_TEXT,
    payload: { data, history, callback }
  }
}

// edit schor horizontal text
export const editSchorHorizontalText = (data, id, callback) => {
  return {
    type: EDIT_SCHOR_HORIZONTAL_TEXT,
    payload: { data, id, callback },
  }
}

// list schor horizontal text
export const listSchorHorizontalText = (data, id, callback) => {
  return {
    type: LIST_SCHOR_HORIZONTAL_TEXT,
    payload: { data, id, callback },
  }
}

// view schor horizontal text
export const viewSchorHorizontalText = (data, history) => {
  return {
    type: VIEW_SCHOR_HORIZONTAL_TEXT,
    payload: { data, history },
  }
}

// delete schor horizontal text
export const deleteSchorHorizontalText = (data, callback) => {
  return {
    type: DELETE_SCHOR_HORIZONTAL_TEXT,
    payload: { data, callback },
  }
}

export const schorHorizontalSuccess = message => {
  return {
    type: SCHOR_HORIZONTAL_SUCCESS,
    payload: message,
  }
}

export const schorHorizontalError = message => {
  return {
    type: SCHOR_HORIZONTAL_ERROR,
    payload: message,
  }
}
